import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock/lib/bodyScrollLock';
import {globalActions} from '../../store/global-actions';
import _u from '../../shared/utils';

const disableHtmlScrollMixin = {
    methods: {
        _disableScroll(disable, el) {
            el = this._getScrolledElement(el);

            if (disable) {
                disableBodyScroll(el,
                    {
                        reserveScrollBarGap: true,
                        allowTouchMove: (e) => {
                            while (e && e !== document.body) {
                                if (e.getAttribute('body-scroll-lock-ignore') !== null) {
                                    return true;
                                }

                                e = e.parentNode;
                            }
                        },
                    });
            } else {
                enableBodyScroll(el);
            }
        },

        _getScrolledElement(e) {
            let el = e ? e : window.document.documentElement;

            if (this._isSimplebar(el)) {
                el = el.getElementsByClassName('simplebar-content-wrapper')[0];
            }

            return el;
        },

        _isSimplebar(el) {
            return el.firstChild && el.firstChild.classList && el.firstChild.classList.contains('simplebar-wrapper');
        },
    },
};

const formValidationMixin = {
    data() {
        return {
            summaryErrors: [],
        };
    },
    computed: {
        hasSummaryErrors() {
            return this.summaryErrors && this.summaryErrors.length > 0;
        },

        validationModel: function() {
            throw Object.assign(new Error('Provide validation modal'));
        },
    },
    watch: {
        'errors.items'(errors) {
            const modelFields = Object.keys(this.validationModel);

            errors.forEach((error) => {
                if (!modelFields.includes(error.field) && !this.summaryErrors.includes(error.msg)) {
                    this.summaryErrors.push(error.msg);
                }
            });
        },
    },
    methods: {
        _handleValidationErrors(errorResult) {
            if (errorResult &&
                errorResult.response &&
                errorResult.response.data &&
                errorResult.response.data.validationErrors) {
                this._addValidationErrors(errorResult.response.data.validationErrors);
            } else if (errorResult) {
                globalActions.handleAjaxErrors(errorResult.response);
            }
        },

        _scrollToValidationErrors() {
            this.$nextTick(() => {
                const errorEl = this.$el.querySelector('.field-validation-error');

                if (errorEl) {
                    if (errorEl.classList.contains('form__validation-summary')) {
                        errorEl.scrollIntoView(true);
                    } else if (errorEl.parentElement) {
                        // NOTE: We assume that validation error and input has the same parent
                        errorEl.parentElement.scrollIntoView(true);
                    }
                }
            });
        },

        _addValidationErrors(errors) {
            if (errors) {
                return errors.forEach((error) => {
                    this.summaryErrors.push(error.errorMessage);
                });
            }
        },

        _clearErrors() {
            this.summaryErrors = [];
            // TODO: introduce errors prop instead of injected $validator
            // this.errors.clear();
        },
    },
};

const googleAnalyticMixin = {
    props: {
        gaSubject: {
            type: String,
            required: false,
            default: null,
        },
    },
    computed: {
        gaId() {
            return this.gaSubject ? `${this.gaSubject}${_u.genUid()}` : null;
        },
    },
};

const hideFeedbackButtonMixin = {
    props: {
        isMobileDevice: {
            type: Boolean,
            required: true,
        },
    },
    mounted() {
        if (this.isMobileDevice) {
            globalActions.hideFeedbackButton();
        }
    },
};

export {
    disableHtmlScrollMixin,
    formValidationMixin,
    googleAnalyticMixin,
    hideFeedbackButtonMixin,
};
